import { SearchResultItem, SearchResultProfile } from './types';

export const isProfile = (result: SearchResultItem): result is SearchResultProfile =>
  result.type === 'practice' || result.type === 'practitioner';
